import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer>
      <center>
        <p>
          &copy; Copyright <b>{new Date().getFullYear()} NFRAC</b>. All Rights Reserved<br />Designed
          by Er. P. Rohit V. Acharya
        </p>
        <div>
          <img
            onClick={() => {
              window.open("https://www.facebook.com/Rohit.pidishetty", "_self");
            }}
            src="social-media/facebook-logo.png"
          />
          <img
            onClick={() => {
              window.open("https://github.com/rohitpidishetty", "_self");
            }}
            src="social-media/github.png"
          />
          <img
            onClick={() => {
              window.open(
                "https://www.instagram.com/rohit_pidishetty/?hl=en",
                "_self"
              );
            }}
            src="social-media/instagram.png"
          />
          <img
            onClick={() => {
              window.open(
                "https://www.linkedin.com/in/er-p-rohit-v-acharya-35884b212/",
                "_self"
              );
            }}
            src="social-media/linkedin.png"
          />
          <img
            onClick={() => {
              window.open("https://twitter.com/rohitpidishett1", "_self");
            }}
            src="social-media/twitter.png"
          />
          <img
            onClick={() => {
              window.open(
                "https://www.youtube.com/channel/UCl1ta3StOr8hmyuMv_7wydA",
                "_self"
              );
            }}
            src="social-media/youtube.png"
          />
        </div>
      </center>
    </footer>
  );
}

export default Footer;
